import { useEffect, useState } from 'react';
import axios from 'axios';

const useFetch = (url, successCode, timeout = 1, init = false) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (init) {
      fetch();
    }
  }, []);

  const fetch = (callback = null) => {
    //setData(null);
    setError(null);
    setIsLoading(true);

    axios.get(url, {"Content-Type": 'application/json'})
      .then((res) => {
        if (successCode === res.data.code){
          setTimeout(() => {
            setData(res.data);  
          }, timeout);
        }
        else{
          setError(res.data.code);
        }
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setTimeout(() => {
          setIsLoading(false);
          if (callback){
            callback();
          }
        }, timeout + 1);  
      });
  }

  const reFetch = (callback) => {
    fetch(callback);
  }

  return [{
    data: data,
    isLoading: isLoading,
    error: error
  }, reFetch];
}

export default useFetch;